import wrapWithProvider from './wrap-with-provider';
import 'isomorphic-fetch';
import './src/styles/global.css';
import '@lux/components-gomo/build/lux-components.css';

export const wrapRootElement = wrapWithProvider;
